import { connect } from 'react-redux';

import { FFState } from '../../../ff/state';
import withTranslate from '../../hoc/with-translate';
import { RoleIcons as Component } from '../../components/role-icons/role-icons';

const mapStateToProps = (state: FFState) => ({
  rolesMap: state.roles.map,
});

export const RoleIcons = connect<
  ReturnType<typeof mapStateToProps>,
  {},
  { roles?: string[]; containerClassName?: string; iconClassName?: string }
>(mapStateToProps)(withTranslate(Component));
